"use client"

import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import Link from 'next/link';

function MediaBoxes({ title, subtitle, buttonText, url, index }) {
    const direction = index % 2 === 0 ? -100 : 100; 

    return (
        <motion.div
            initial={{ opacity: 0, x: direction }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            viewport={{ once: true }}
            className="p-6 bg-[#FAF9FE] flex flex-col justify-center rounded-lg shadow-md mx-auto sm:px-8 lg:w-[1202px] lg:h-[330px]"
        >
            <h2 className="text-[24px] sm:text-[36px] font-bold font-lato bg-custom-radial bg-clip-text text-transparent">{title}</h2>
            <p className="text-[20px] sm:text-[28px] text-[#E56717] mt-2 font-bold font-lato">{subtitle}</p>
            {/* <p className="text-gray-700 mt-4 lg:mt-10 text-sm sm:text-base font-lato lg:w-[90%]">{description}</p> */}
            <Link href={url} target='_blank'>
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="mt-6 bg-[#E56717] text-white py-2 px-4 rounded hover:bg-orange-600 transition w-full lg:w-[260px] sm:w-auto font-lato text-[14px]"
                >
                    {buttonText}
                </motion.button>
            </Link>
        </motion.div>
    );
}

MediaBoxes.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
};

export default MediaBoxes;